import { UnitTransferDocumentStatusEnumType } from '__generated__/graphql';

export default function unitTransferDocumentStatusToReadable(
  status: UnitTransferDocumentStatusEnumType
): {
  label: string;
  color: string;
} {
  switch (status) {
    case UnitTransferDocumentStatusEnumType.PendingUpload:
      return { label: 'Pending Upload', color: 'gray' };
    case UnitTransferDocumentStatusEnumType.Uploaded:
      return { label: 'Uploaded', color: 'sky' };
    case UnitTransferDocumentStatusEnumType.AiChecked:
      return { label: 'AI Checked', color: 'amber' };
    case UnitTransferDocumentStatusEnumType.Approved:
      return { label: 'Approved', color: 'green' };
    case UnitTransferDocumentStatusEnumType.Rejected:
      return { label: 'Rejected', color: 'red' };
    case UnitTransferDocumentStatusEnumType.Superseded:
      return { label: 'Superseded', color: 'gray' };
    default:
      return { label: status, color: 'gray' };
  }
}
